var AsyncState = (function () {
    function AsyncState(initialData) {
        this.data = null;
        this.isFetching = false;
        this.error = null;
        this.errorTimestamp = null;
        this.timestamp = null;
        this.data = initialData;
    }
    return AsyncState;
}());
export { AsyncState };
